import {
    ChangeDetectionStrategy,
    Component,
    OnChanges,
    SimpleChanges,
    effect,
    inject,
    input,
    output,
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs';

import {
    MobiUiFormErrorMessageDirective,
    MobiUiFormFieldComponent,
    MobiUiFormMessageComponent,
    MobiUiInputComponent,
} from '@mobi/rwc-ui-components-ng-jslib';
import { TranslatePipe } from '@mobi/rwc-utils-ng-jslib';

import { SearchParam } from '../../model/search-param';

@Component({
    selector: 'oiv-viewer-search-box',
    imports: [
        ReactiveFormsModule,
        MobiUiFormFieldComponent,
        MobiUiInputComponent,
        MobiUiFormMessageComponent,
        TranslatePipe,
        MobiUiFormErrorMessageDirective,
    ],
    templateUrl: './search-box.component.html',
    styleUrl: './search-box.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBoxComponent implements OnChanges {
    keySearch = input<string>('');
    isDisabled = input<boolean>(false);
    searchTextChange = output<SearchParam>();
    #fb = inject(FormBuilder);
    searchForm: FormGroup = this.#fb.group({
        query: [this.keySearch(), Validators.required],
    });

    constructor() {
        this.searchForm
            ?.get('query')
            ?.valueChanges.pipe(debounceTime(500))
            .subscribe(value => {
                this.searchTextChange.emit({
                    text: value,
                } as SearchParam);
            });
        effect(() => {
            this.searchForm.get('query')?.setValue(this.keySearch());
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['isDisabled']) {
            this.searchForm.get('query')?.[this.isDisabled() ? 'disable' : 'enable'](); // Disable the input field if index is not READY
        }
    }

    clear(): void {
        this.searchForm.get('query')?.setValue('');
    }
}
